import React, { useEffect } from "react";
import styles from "../assets/scss/pages.module.scss";
import PersonalInfo from "sections/artistPage/personalInfo/PersonalInfo";
import Paintings from "sections/artistPage/paintings/Paintings";
import Media from "sections/artistPage/media/Media";
import Studio from "sections/artistPage/studio/Studio";

const SingleArtistPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <div className={styles.artistPage}>
      <div className="container">
        <h2 className={styles.title}>NAME LASTNAME fathername</h2>
        <PersonalInfo />
        <Paintings />
        <Media />
        <Studio />
      </div>
    </div>
  );
};

export default SingleArtistPage;
